import type { IconProps } from './types';
import './icons.css';

export default function Copy({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-copy ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M13.125 17.292h-8.75c-.92 0-1.667-.747-1.667-1.667v-8.75c0-.92.746-1.667 1.667-1.667h8.75c.92 0 1.667.747 1.667 1.667v8.75c0 .92-.747 1.667-1.667 1.667Z"
      />
      <path
        fill="currentColor"
        d="M15.625 2.083h-8.75c-.888 0-1.658.51-2.039 1.25h10.789c.575 0 1.042.467 1.042 1.042v10.789c.74-.38 1.25-1.15 1.25-2.039v-8.75a2.295 2.295 0 0 0-2.292-2.292Z"
      />
    </svg>
  );
}
